import axios from "../http-config/axiosConfig";

const UsersApi = {
	getOrganizationUsersAsync: async () => {
		const { data } = await axios.get("/Admin/Users/GetOrganizationUsers");
		return data.result.map((userOption) => ({
			id: userOption.id,
			email: userOption.label,
		}));
	},

	getUsersAsync: async () => {
		const { data } = await axios.get("/Admin/Users/GetUsers");
		return data.result;
	},

	getUserSuggestionsAsync: async (searchTerm) => {
		const { data } = await axios.get(`/Admin/Users/GetUserSuggestions?searchTerm=${searchTerm}`);
		return data.result;
	},

	getUserAsync: async (email) => {
		const { data } = await axios.get(`/Admin/Users/GetUser?email=${email}`);
		return data.result;
	},

	getUserByGraphIdAsync: async (id) => {
		const { data } = await axios.get(`/Admin/Users/GetUserByGraphId?id=${id}`);
		return data.result;
	},

	submitUserSettingsAsync: async (settings) => {
		const { data } = await axios.post("/Admin/Users/Submit", settings);
		return data;
	},

	getToken: async (email) => {
		const { data } = await axios.get(`/Admin/Users/Token/${email}`);
		return data;
	},
};

export default UsersApi;
